import React, { useState } from 'react';
import { NavigationLinkWithIcon, ButtonWithBigIcon } from './TopNavStyles';
import { HelpModal } from '../Components/Help/components/HelpModal/HelpModal';
import { DemoModal } from '../Components/Help/components/DemoModal/DemoModal';
import { ContactModal } from '../Components/Help/components/ContactModal/ContactModal';

const HELP = 'help';
const DEMO = 'demo';
const CONTACT = 'contact';

export default () => {
  const [modalStep, setModalStep] = useState(null);

  return (
    <>
      <NavigationLinkWithIcon>
        <ButtonWithBigIcon
          id="btn-help"
          title="Help"
          prependIcon="fa fa-question-circle"
          aria-label="help"
          onClick={() => setModalStep(HELP)}
        />
      </NavigationLinkWithIcon>

      {modalStep === HELP && (
        <HelpModal
          onClose={() => setModalStep(null)}
          onDemo={() => setModalStep(DEMO)}
          onContact={() => setModalStep(CONTACT)}
        />
      )}

      {modalStep === DEMO && (
        <DemoModal onClose={() => setModalStep(null)} onBack={() => setModalStep(HELP)} />
      )}

      {modalStep === CONTACT && (
        <ContactModal onClose={() => setModalStep(null)} onBack={() => setModalStep(HELP)} />
      )}
    </>
  );
};
